var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-wrapper__header"},[_c('div',{staticClass:"form-wrapper__title"},[_vm._t("form-title")],2)]),_vm._t("form-groups")],2)}
var staticRenderFns = []

export { render, staticRenderFns }